import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { Landing } from '../pages/landing';
import { Privacy } from '../pages/privacy';
import { Tos } from '../pages/tos';

const browserRouter = createBrowserRouter([
  {
    path: '/',
    Component: Landing,
  },
  {
    path: '/tos',
    Component: Tos,
  },
  {
    path: '/privacy',
    Component: Privacy,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

export function StaticLandingPageRoutes() {
  return <RouterProvider router={browserRouter} />;
}
